import { Button } from "@component/button";
import RejectionIcon from "@component/rejection-icon";

interface Props {
    isApplyFlow?: boolean;
    isQuickApply?: boolean;
    onContinue?: () => void;
    onRetakeInterview?: () => void;
    description?: React.ReactNode;
    /**
     * Override for the "View Partial Insights" action. When set, the
     * button calls this instead of the default
     * `window.location.href = '/interview/assessment'` navigation.
     * Used by AiInterview to route to the specific assessment id
     * (e.g. `/interview/<interviewid>`).
     */
    onViewPartialInsights?: () => void;
}

export default function InterviewShortCard(props: Props) {
    return (
        <div
            className="bg-white dark:bg-gray-900 rounded-3xl p-8 shadow-2xl text-center w-full mx-auto"
            style={{
                boxShadow: '0px 0px 0px #000000, 0px 4px 30px -4px rgba(0, 0, 0, 0.3)'
            }}
        >
            <RejectionIcon
                className={`mx-auto mb-6`}
                variant={"interview-short"}
            />

            <h1 className="text-3xl font-bold mb-2">
                Interview Too Short
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mb-8 mx-auto whitespace-pre-line">
                {props.description}
            </p>
            {props.onRetakeInterview && (
                <>
                    {props.isApplyFlow ? (
                        <>
                            <Button
                                variant="default"
                                className={`w-full sm:w-auto bg-blue-600 flex-1 `}
                                onClick={props.onRetakeInterview}
                            >
                                Retake Interview
                            </Button>
                        </>
                    ) : props.isQuickApply ? (
                        <div className="flex flex-row justify-center items-center gap-4 w-full">
                            <Button
                                variant="outline"
                                className={`w-full sm:w-auto flex-1 `}
                                onClick={props.onRetakeInterview}
                            >
                                Retake Interview
                            </Button>
                            <Button
                                variant="default"
                                className={`w-full sm:w-auto bg-blue-600 flex-1 `}
                                onClick={props.onContinue}
                            >
                                Continue
                            </Button>
                        </div>
                    ) : (
                        <div className="flex flex-row justify-center items-center gap-4 w-full">
                            <Button
                                variant="outline"
                                className={`w-full sm:w-auto flex-1 `}
                                onClick={props.onRetakeInterview}
                            >
                                Retake Interview
                            </Button>
                            <Button
                                variant="default"
                                className={`w-full sm:w-auto bg-blue-600 flex-1 `}
                                onClick={() => {
                                    if (props.onViewPartialInsights) {
                                        props.onViewPartialInsights();
                                        return;
                                    }
                                    window.location.href = '/interview/assessment';
                                }}
                            >
                                View Partial Insights
                            </Button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
